export const CHARGE_TYPES = ['SHIPMENT', 'DECLARATION', 'CONTAINER', 'WEIGHT', 'PERCENTAGE'];
export const CHARGE_CATEGORIES = [
  'COLLECTION',
  'CONTAINER_CLEARANCE',
  'CONTAINER_MAINTENANCE',
  'CUSTOMS_CLEARANCE',
  'DELIVERY',
  'DOCUMENTATION',
  'FREIGHT',
  'FUEL_SURCHARGE',
  'HANDLING_CHARGE',
  'INSPECTION',
  'OVERTIME',
  'PICK_UP',
  'PICK_UP_AND_DROP_OFF',
  'PORT_CHARGES',
  'SEAL_FEE',
  'SPECIAL_HANDLING',
  'STORAGE',
  'THC',
  'TOTAL_ORIGIN_CHARGES',
  'VGM_FEE',
  'DEFAULT_CHARGE_DOMAIN',
  'SCREE',
];
export const CALCULATION_METHODS = ['MIN_OR_UNIT_PRICE', 'MIN_AND_UNIT_PRICE'];
export const LEG_TYPES = ['LEG_ONE', 'LEG_TWO', 'LEG_THREE'];
export const CHARGE_UNIT = ['KG', 'CBM', 'PKG'];
export const CONTAINER_TYPES = ['STANDARD', 'HIGH_CUBE', 'OPEN_TOP'];
export const CHARGE_NAMES = [
  'ADDITIONAL_CUSTOM_SET',
  'AIR_FREIGHT',
  'AIR_RIDE_20_FEET',
  'AIR_RIDE_40_FEET',
  'AIR_RIDE_40_FEET_HC',
  'AIR_RIDE_40_FEET_LOW_BED',
  'AMS',
  'BAF',
  'CAF',
  'BL_FEE_EXPORT',
  'BL_FEE_IMPORT',
  'COLLECTION_CHARGES',
  'CONSOLE_COLLECTION',
  'CONSOLE_DELIVERY',
  'CONTAINER_MAINTENANCE',
  'CUSTOMS_DOCUMENTATION',
  'CUSTOMS_EXAMINATION',
  'CUSTOMS_FORM_CLEARANCE',
  'DEDICATED_TRUCK',
  'DEDICATED_TRUCK_20_FEET',
  'DEDICATED_TRUCK_40_FEET',
  'DEDICATED_TRUCK_40_FEET_PER_ADDITIONAL_HOUR',
  'DEDICATED_TRUCK_AIR_RIDE',
  'DEDICATED_TRUCK_GENERAL',
  'DEDICATED_TRUCK_GENERAL_1_TON',
  'DEDICATED_TRUCK_GENERAL_2_TON',
  'DEDICATED_TRUCK_GENERAL_3_TON',
  'DEDICATED_TRUCK_GENERAL_5_TON',
  'DEDICATED_TRUCK_GENERAL_8_TON',
  'DEDICATED_TRUCK_GENERAL_10_TON',
  'DEDICATED_TRUCK_OVERHEIGHT',
  'DELIVERY_CHARGES',
  'DESTINATION_HANDLING',
  'DESTINATION_STORAGE',
  'DO_FEE',
  'EDI',
  'EXCEEDING_DISTANCE',
  'EXPORT',
  'EXPRESS_CLEARANCE',
  'FOB',
  'FORK_LIFT_CHARGES',
  'GST_INTERNATIONAL_PERMIT',
  'HANDLING_CLEARANCE',
  'IMPORT',
  'LTL_FREIGHT',
  'MAGNETIC_INSPECTION',
  'NAME',
  'OCEAN_FREIGHT',
  'ORIGIN_AES',
  'ORIGIN_HANDLING',
  'OVERTIME_CHARGE',
  'OVERTIME_CHARGE_WEEKDAY_AFTER_WORKING_HOUR',
  'OVERTIME_CHARGE_WEEKEND_PUBLIC_HOLIDAY',
  'PERMIT',
  'PICK_UP_AND_DROP_OFF',
  'PICK_UP_CHARGES',
  'PORT_CHARGES',
  'Q7_AIR_RIDE',
  'ROAD_EXPORT',
  'SEAL_FEE',
  'SURVEY_FEE',
  'THIRD_PARTY',
  'TOTAL_CUSTOMS',
  'TRANSHIPMENT_PERMIT',
  'URGENT_DELIVERY_CHARGES',
  'VGM_FEE',
  'OVERTIME_CHARGE_WEEKDAY_AFTER_WORKING_HOUR_AIR_RIDE',
  'OVERTIME_CHARGE_WEEKEND_PUBLIC_HOLIDAY_AIR_RIDE',
  'SUBSEQUENT_HOUR',
  'SURVEY_ATTENDANCE',
  'STORAGE_36HR',
  'STORAGE_72HR',
  'AGENCY_FEE',
  'FUEL_SURCHARGE',
  'TERMINAL_HANDLING',
  'THC',
  'CLEANING_FEE',
  'BOOKING_FEE',
  'PROCESSING_FEE',
  'CONTAINER_UNSTUFFING',
  'CONTAINER_HANDLING',
  'TAILGATE_SURCHARGE',
  'SUPPLY_OF_TRANSPORT',
  'OVERTIME_MIDNIGHT_DELIVERY_SUBSEQUENT_HOURS',
  'DEDICATED_TRUCK_14_FOOT',
  'DEDICATED_TRUCK_14_FOOT_SUBSEQUENT_HOURS',
  'DEDICATED_TRUCK_24_FOOT',
  'DEDICATED_24_FOOT_SUBSEQUENT_HOURS',
  'OVERTIME_CHARGE_WEEKDAY_AFTER_WORKING_HOUR_SUBSEQUENT_HOURS',
  'OVERTIME_CHARGE_SATURDAY',
  'OVERTIME_CHARGE_SATURDAY_SUBSEQUENT_HOURS',
  'OVERTIME_SUNDAY_HOLIDAY',
  'OVERTIME_SUNDAY_HOLIDAY_SUBSEQUENT_HOURS',
  'OVERTIME_MIDNIGHT_DELIVERY',
  'SCREENING',
  'SHORING_LASHING',
  'DEFAULT_CHARGE_SUB_DOMAIN',
  'SUM_CUSTOM',
  'CUSTOM_FORM_CLEARANCE_IMPORT',
  'CUSTOM_FORM_CLEARANCE_EXPORT',
  'CUSTOM_FORM_CLEARANCE',
  'CUSTOMS_EXPORT',
];
